import { makeStyles } from 'tss-react/mui';

const useStylesDrawer: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  drawer: {
    flexShrink: 0,
    zIndex: `${(theme.zIndex as MaterialUIThemeZIndex).drawer} !important`,
  },
  drawerPaper: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.common.white} !important`,
  },
  drawerPaperSecondary: {
    backgroundColor: `${theme.palette.primary.light} !important`,
    color: `${theme.palette.common.black} !important`,
  },
}));

export default useStylesDrawer;
